module.exports = __webpack_public_path__ + "img/icon-vainnce.ebed028a.png";